// Generated by ReScript, PLEASE EDIT WITH CARE

import * as LatLng$PorterinFeature from "./LatLng.mjs";

function initial_extended_address(param) {
  return {
          state: undefined,
          city: undefined,
          pincode: undefined,
          locality: undefined,
          sub_locality: undefined
        };
}

function initial_address(param) {
  return {
          landmark: "",
          location: LatLng$PorterinFeature.initial_lat_lng(undefined),
          extended_address: {
            state: undefined,
            city: undefined,
            pincode: undefined,
            locality: undefined,
            sub_locality: undefined
          }
        };
}

export {
  initial_extended_address ,
  initial_address ,
}
/* No side effect */
